export enum Prioridade {
  URGENT = 'urgente',
  IMPORTANT = 'importante',
  NORMAL = 'normal'
}

export enum Status {
  PENDENTE = 'pendente',
  CONCLUIDA = 'concluída'
}
